import React from "react";
import LandingPage from "./Pages/LandingPage";
import "./style.scss";

function App() {
  return <LandingPage />;
}

export default App;
